import { Star, Quote } from "lucide-react";
import { HIGHLIGHTS, REVIEWS } from "./data";
import { Reveal, Eyebrow } from "./motion";

const Stars = ({ c = "w-4 h-4" }) => <div className="flex gap-1">{[...Array(5)].map((_, i) => <Star key={i} className={`${c} fill-[#FF6A13] text-[#FF6A13]`} />)}</div>;

export const Reviews = () => (
  <section id="avaliacoes" className="relative bg-[#F4EFE6] py-24 md:py-36" data-testid="reviews-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow dark>Quem comprou, indica</Eyebrow>
        <div className="mt-8 flex items-end gap-4">
          <span className="font-display font-black text-[#0A0E3F] text-[8rem] md:text-[10rem] leading-[0.8] tracking-[-0.06em]" data-testid="reviews-rating">4,8</span>
        </div>
        <div className="mt-6"><Stars c="w-6 h-6" /></div>
        <p className="mt-3 text-[#0A0E3F]/75" data-testid="reviews-count">19 avaliações no Google</p>
      </Reveal>
      <div className="lg:col-span-8 grid gap-5">
        {HIGHLIGHTS.map((h, i) => (
          <Reveal key={h} delay={i * 0.08}>
            <p className="group font-display font-bold text-[#0A0E3F] text-2xl md:text-4xl tracking-tight leading-tight border-b border-[#0A0E3F]/15 pb-6 hover:text-[#1E2AA8] transition-colors duration-500" data-testid={`review-highlight-${i}`}>
              <span className="text-[#FF6A13] mr-2">“</span>{h}<span className="text-[#FF6A13]">”</span>
            </p>
          </Reveal>
        ))}
        <div className="grid md:grid-cols-2 gap-5 mt-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1}>
              <article className="h-full rounded-[24px] bg-[#0A0E3F] text-white p-7 md:p-8 hover:-translate-y-1 transition-transform duration-500" data-testid={`review-card-${i}`}>
                <Quote className="w-8 h-8 text-[#FFB020]" />
                <p className="mt-5 text-lg leading-relaxed text-white/90">{r.text}</p>
                <div className="mt-8 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="grid place-items-center w-10 h-10 rounded-full bg-[#FF6A13] text-[#0A0E3F] font-display font-black">{r.name[0]}</span>
                    <div><p className="font-semibold">{r.name}</p><p className="text-xs text-white/65">{r.when}</p></div>
                  </div>
                  <Stars c="w-3.5 h-3.5" />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
